





























import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class TableArrows extends Vue {
    @Prop() enableAddArrow: boolean;
    @Prop() enableRemoveArrow: boolean;
    @Prop({ default: false }) addOnly: boolean;

    @Emit()
    addArrowClick() {}

    @Emit()
    removeArrowClick() {}
    mounted() {}
}
